import PromoContainer from './PromoContainer';

export default PromoContainer;
